import Vue from 'vue';
import VueRouter from 'vue-router';
import Constantes from '@constants';
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta';
// Adds a loading bar at the top during page loads.
import NProgress from 'nprogress/nprogress';
import store from '@state/store';
import routes from './routes';
import state from '@state/store.js';
import Notification from '@utils/notification';

Vue.use(VueRouter);
Vue.use(VueMeta, {
	keyName: 'page'
});

const router = new VueRouter({
	routes,
	mode: 'history'
});

router.beforeEach((routeTo, routeFrom, next) => {
	if (routeFrom.name !== null) {
		NProgress.start();
	}
	return next();
});

router.beforeEach((routeTo, routeFrom, next) => {
	if (routeTo.meta && routeTo.meta.ocupaPermiso) {
		const permiso = routeTo.meta.ocupaPermiso;
		if (
			state &&
			state.state &&
			state.state.oidc &&
			state.state.oidc.user &&
			state.state.oidc.user &&
			state.state.oidc.user.permiso &&
			state.state.oidc.user.permiso.filter(
				(x) =>
					x
						.toString()
						.trim()
						.toUpperCase() ===
					permiso
						.toString()
						.trim()
						.toUpperCase()
			).length === 0
		) {
			Notification(
				'error',
				'¡No cuenta con los permisos necesarios para entrar a la funcionalidad especificada!'
			);
			if (routeFrom && routeFrom.path) {
				return next(routeFrom.path);
			} else {
				return next('/inicio');
			}
		}
	}
	return next();
});

if (Constantes.AUTH_ACTIVE === true) {
	router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidc'));
}

router.beforeResolve(async (routeTo, routeFrom, next) => {
	try {
		for (const route of routeTo.matched) {
			await new Promise((resolve, reject) => {
				if (route.meta && route.meta.beforeResolve) {
					route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
						if (args.length) {
							if (routeFrom.name === args[0].name) {
								NProgress.done();
							}
							next(...args);
							reject(new Error('Redirected'));
						} else {
							resolve();
						}
					});
				} else {
					resolve();
				}
			});
		}
	} catch (error) {
		return;
	}

	next();
});

router.afterEach((routeTo, routeFrom) => {
	NProgress.done();
});

export default router;
